<div class="modal-dialog modal-lg">
    <div class="modal-content">
    
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">Importação para envio em massa</h4>
        <button #closebutton type="button" class="close" data-dismiss="modal" (click)="okImportar(importar)">&times;</button>
    </div>
    
    <!-- Modal body -->
    <div class="modal-body">
        <p>Para importar os emails, selecione abaixo o arquivo (.csv) e em seguida confira os dados.</p>
        
        <input type="file" #importar class="form-control" accept=".csv" (change)="importarCsv($event)">
        <nav *ngIf="criticaValidacao.length > 0 || newEleitores.length > 0 || duplicados.length > 0 || enviados.length > 0" class="mt-3">
            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                <a *ngIf="criticaValidacao.length > 0" class="nav-item nav-link" [ngClass]="ativaNavValidacao == true ? 'active' : '' " 
                    id="nav-validacao-tab" data-toggle="tab" href="#nav-validacao" role="tab" aria-controls="nav-validacao" aria-selected="false">
                    Validação
                </a>
                <a *ngIf="duplicados.length > 0" class="nav-item nav-link" [ngClass]="ativaNavDuplicados === true ? 'active' : '' " 
                    id="nav-duplicados-tab" data-toggle="tab" href="#nav-duplicados" role="tab" aria-controls="nav-duplicados" 
                    aria-selected="true">
                    Duplicados
                </a>
                <a *ngIf="newEleitores.length > 0 && enviados.length === 0" class="nav-item nav-link" 
                    [ngClass]="ativaNavEnviar == true ? 'active' : '' " id="nav-enviar-tab" data-toggle="tab" href="#nav-enviar" 
                    role="tab" aria-controls="nav-enviar" aria-selected="false">
                    Lista de Envio
                </a>
            </div>
        </nav>
        <div *ngIf="criticaValidacao.length > 0 || newEleitores.length > 0 || duplicados.length > 0 || enviados.length > 0" class="tab-content" id="nav-tabContent">
            <div *ngIf="criticaValidacao.length > 0" class="tab-pane fade" [ngClass]="ativaNavValidacao == true ? 'show active' : '' " id="nav-validacao" role="tabpanel">
                <div class="mt-2">
                    <div class="alert alert-danger mt-2" role="alert">
                        <p class="mb-0">Os eleitores não passaram em alguma validação.</p>
                        <p class="mb-0">Validação 1: É necessário informar o login do eleitor.</p>
                        <p class="mb-0">Validação 2: Não é permitido o uso de espaços no login.</p>
                        <p class="mb-0">Validação 3: Os únicos caracteres especiais permitidos são "@", "-", "_" e "."!</p>
                        <p class="mb-0">Validação 4: É necessário informar um e-mail válido para o eleitor.</p>
                    </div>
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Login</th>
                                <th>Email</th>
                                <th>Crítica Validação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let valida of criticaValidacao">
                                <td>{{valida.eleitorCriticado.login}}</td>
                                <td>{{valida.eleitorCriticado.email}}</td>
                                <td>{{valida.critica}}</td>
                            </tr>
                        </tbody>
                    </table>          
                </div>
            </div>

            <div *ngIf="newEleitores.length > 0" class="tab-pane fade" [ngClass]="ativaNavEnviar == true ? 'show active' : '' " id="nav-enviar" role="tabpanel">
                <div class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Login</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eleitor of newEleitores | paginate: { itemsPerPage: contador, currentPage: paginaAtual }">
                                <td>{{eleitor.login}}</td>
                                <td>{{eleitor.email}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="text-right">
                        <pagination-controls (pageChange)="paginaAtual = $event" previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
                    </div>
                </div>
                <button *ngIf="newEleitores.length > 0" class="btn-custom btn btn-success mt-3" (click)="importarList()">
                    Carrega Lista de Envio
                </button>
            </div>

            <div *ngIf="duplicados.length > 0" class="tab-pane fade" [ngClass]="ativaNavDuplicados === true ? 'show active' : '' " id="nav-duplicados" role="tabpanel">
                <div class="alert alert-danger mt-2" role="alert">
                    <p class="mb-0">Os eleitores abaixo já estão cadastrados.</p>
                </div>
                <div *ngIf="duplicados.length > 0" class="mt-2">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Login</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eleitor of duplicados">
                                <td>{{eleitor.login}}</td>
                            </tr>
                        </tbody>
                    </table>              
                </div>
            </div>
        </div>
        <hr>
        <button *ngIf="newEleitores.length === 0" class="btn-custom btn btn-success" data-dismiss="modal" (click)="okImportar(importar)">
            Ok
        </button>
        <button class="btn-custom btn btn-light mr-2" (click)="zerarInputFile(importar)">
            Descartar arquivo
        </button>  
    </div>        
    </div>
</div>